// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3Dpit","overflowing":"ReadFullNote_overflowing__rvce3"};